import React, { useState } from "react";
import Button from "../../../../components/form/Button";
import { Link } from "react-router-dom";
import Select from "../../../../components/form/select/Select";
import Input from "../../../../components/form/Input";
import Checkbox from "../../../../components/form/Checkbox";
import DatePicker from "../../../../components/form/DatePicker";

const AttendeeManage = () => {
  const [selectedPrefix, setselectedPrefix] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedGender, setselectedGender] = useState("");
  
  const handlePrefixChange = (value, item) => {
    setselectedPrefix(value);
  };
  const handleCountryChange = (value, item) => {
    setSelectedCountry(value);
  };
   const handleGenderChange = (value, item) => {
    setselectedGender(value);
  };
  const prefixOptions = [
    { id:1, value: "1", name: "Mr.",  },
    { id:2, value: "2", name: "Mrs.",},
    { id:3, value: "3", name: "Ms.",  },
    { id:4, value: "4", name: "Miss",  },
    { id:5, value: "5", name: "Mx",  },
    { id:6, value: "6", name: "Dr.",  },
    { id:7, value: "7", name: "Prof.",  },
    { id:8, value: "8", name: "Rev.",  },
  ];
  const countryOptions = [
    { name: "India", value: "IN", icon: "fa-solid fa-flag" },
    { name: "United States", value: "US", icon: "fa-solid fa-flag-usa" },
    { name: "Germany", value: "DE", icon: "fa-solid fa-flag" },
    { name: "Australia", value: "AU", icon: "fa-solid fa-flag" },
  ];
  const genderOptions = [
    { name: "Male", value: "male", icon: "fa-regular fa-person" },
    { name: "Female", value: "female", icon: "fa-regular fa-person-dress" },
    { name: "Other", value: "other", icon: "fa-regular fa-users" },
  ];
  return (
    <div className="max-w-full mx-auto bg-white py-4 px-4 rounded-md shadow-xl border border-slate-200 space-y-3">
      <h1 className="text-3xl font-bold text-slate-900">Edit Attendee Information</h1>
      <div className="text-base text-slate-600">
        <strong>cfdf</strong> 1 – 0.00 (
        <Link to="#" className="text-deep-purple underline">Order #12816405373</Link>)
        <div className="mt-1 text-sm">You can <Link to="" className="underline text-deep-purple">customize the info you collect</Link> during attendee registration.</div>
      </div>
      <div className="py-8 px-6 rounded-md space-y-4 border border-gray-200">
        <div className="grid grid-cols-12 gap-5">
            <div className="col-span-12">
                <div className="text-3xl text-deep-purple font-bold capitalize">contact information</div>
            </div>
            <div className="col-span-4">
                <Select
                  label="Prefix"
                  labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                  dropdownData={prefixOptions}
                  selectedValue={selectedPrefix}
                  onChange={handlePrefixChange}
                  placeholder=""
                  xPlacement="bottomLeft"
                  dropdownClass={"w-full"}
                  dropdownButtonClass={"rounded-md"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"First name"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                    value={"Symlink"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Surname"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                    value={"Demo"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"suffix"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"email"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputType="email"
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                    value={"symlinktestmail@gmail.com"}
                />
            </div>
            <div className="col-span-12">
                <Checkbox
                    checkboxLabel={"Send confirmation email to new attendee"}
                    checkboxLableClass={"text-slate-700 text-lg font-medium"}
                />
            </div>
        </div>
      </div>
      <div className="py-8 px-6 rounded-md space-y-4 border border-gray-200">
        <div className="grid grid-cols-12 gap-5">
            <div className="col-span-12">
                <div className="text-3xl text-deep-purple font-bold capitalize">Home Address</div>
            </div>
            <div className="col-span-4">
                <Input
                    label={"Address"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Address 2"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"city"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"state"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Postcode"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Select
                  label="Country"
                  labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                  dropdownData={countryOptions}
                  selectedValue={selectedCountry}
                  onChange={handleCountryChange}
                  placeholder=""
                  xPlacement="bottomLeft"
                  dropdownClass={"w-full"}
                  dropdownButtonClass={"rounded-md"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Phone"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Mobile Phone"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
        </div>
      </div>
      <div className="py-8 px-6 rounded-md space-y-4 border border-gray-200">
        <div className="grid grid-cols-12 gap-5">
            <div className="col-span-12">
                <div className="text-3xl text-deep-purple font-bold capitalize">Shipping Address</div>
            </div>
            <div className="col-span-4">
                <Input
                    label={"Address"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Address 2"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"city"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"state"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Postcode"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Select
                  label="Country"
                  labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                  dropdownData={countryOptions}
                  selectedValue={selectedCountry}
                  onChange={handleCountryChange}
                  placeholder=""
                  xPlacement="bottomLeft"
                  dropdownClass={"w-full"}
                  dropdownButtonClass={"rounded-md"}
                />
            </div>
        </div>
      </div>
      <div className="py-8 px-6 rounded-md space-y-4 border border-gray-200">
        <div className="grid grid-cols-12 gap-5">
            <div className="col-span-12">
                <div className="text-3xl text-deep-purple font-bold capitalize">Work Info</div>
            </div>
            <div className="col-span-4">
                <Input
                    label={"Job Title"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Company"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Address"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Address 2"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"City"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"State/Territory"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Postcode"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Select
                  label="Country"
                  labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                  dropdownData={countryOptions}
                  selectedValue={selectedCountry}
                  onChange={handleCountryChange}
                  placeholder=""
                  xPlacement="bottomLeft"
                  dropdownClass={"w-full"}
                  dropdownButtonClass={"rounded-md"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Phone"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Website"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Blog"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
        </div>
      </div>
      <div className="py-8 px-6 rounded-md space-y-4 border border-gray-200">
        <div className="grid grid-cols-12 gap-5">
            <div className="col-span-12">
                <div className="text-3xl text-deep-purple font-bold capitalize">Other Info</div>
            </div>
            <div className="col-span-4">
                <Select
                  label="Sex"
                  labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                  dropdownData={genderOptions}
                  selectedValue={selectedGender}
                  onChange={handleGenderChange}
                  placeholder=""
                  xPlacement="bottomLeft"
                  dropdownClass={"w-full"}
                  dropdownButtonClass={"rounded-md"}
                />
            </div>
            <div className="col-span-4">
                <Input
                    label={"Age"}
                    labelClasses={"capitalize !text-lg !text-deep-purple !mb-2"}
                    inputClasses={"h-12 !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
                />
            </div>
            <div className="col-span-4">
                <DatePicker
                  label={"Birth Date"}
                  labelClasses={"!text-lg !text-deep-purple !mb-2"}
                  placeholder={"Select Date"}
                  inputClassName={
                    "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                  }
                  
                />
            </div>
           
        </div>
      </div>
      <div className="flex justify-end gap-2 mt-5">
          <div className="relative">
              <Button
                  buttonLabel={"cancel"}
                  buttonLabelClasses={"text-slate-700"}
                  buttonClasses={"hover:bg-slate-100 border-slate-300 bg-transparent px-4"}
              />
          </div>
          <div className="relative">
              <Button
                  buttonLabel={"Save Changes"}
                  buttonLabelClasses={"text-white"}
                  buttonClasses={"px-4"}
              />
          </div>
      
      </div>
    </div>

  );
};

export default AttendeeManage;
